import request from 'utils/request'
import { resetPassword, confirmResetPassword } from 'aws-amplify/auth'

export function forgottenPassword(data) {
  return request('password/forgotten', {
    method: 'POST',
    data
  })
}

/**
 * Starts the password reset, so Cognito mails a code to the user.
 *
 * @param {Object} data - Forgotten password form values.
 * @param {string} data.email - Email, used as the Cognito username.
 * @returns {Promise<{isPasswordReset: boolean, nextStep: Object}>}
 * @throws Rethrows the Cognito error, for example UserNotFoundException.
 */
export async function forgottenPasswordCognito(data) {
  return resetPassword({ username: data.email })
}

export function recoverPassword(data) {
  return request('password/recover', {
    method: 'POST',
    data
  })
}

/**
 * Finishes the password reset with the code Cognito mailed to the user.
 *
 * It resolves with nothing and throws on error, so the caller treats a clean
 * return as success. In v4 this took three positional arguments.
 *
 * @param {Object} data - Recover password form values.
 * @param {string} data.email - Email, used as the Cognito username.
 * @param {string} data.verificationCode - Code from the mail.
 * @param {string} data.password - New password.
 * @returns {Promise<void>}
 * @throws Rethrows the Cognito error, for example CodeMismatchException.
 */
export async function recoverPasswordCognito(data) {
  return confirmResetPassword({
    username: data.email,
    confirmationCode: data.verificationCode,
    newPassword: data.password
  })
}
